import { initFileViewerModal } from './file_viewer_zoom.js';

let depictorHandlersInstalled = false;

function jobIdComboboxEl(root) {
  var scope = root && root.querySelector ? root : document;
  return (
    scope.querySelector('#jobidmaster_pk[data-init="virtual-select"]')
    || document.getElementById('jobidmaster_pk')
  );
}

function resetJobIdCombobox(el) {
  if (!el) return;
  try {
    if (el.virtualSelect && typeof el.virtualSelect.destroy === 'function') {
      el.virtualSelect.destroy();
    }
  } catch (_e) {
    /* ignore stale VirtualSelect teardown */
  }
  el.removeAttribute('data-initialized');
}

function initJobIdCombobox(root) {
  if (typeof window.initVirtualSelect !== 'function') return false;
  var el = jobIdComboboxEl(root);
  if (!el || el.getAttribute('data-init') !== 'virtual-select') return false;
  resetJobIdCombobox(el);
  window.initVirtualSelect(el);
  var host = el.closest('[id$="_entryform"]') || el;
  if (window.htmx && typeof window.htmx.process === 'function') {
    window.htmx.process(host);
  }
  return el.hasAttribute('data-initialized');
}

function retryJobIdCombobox(root, attempt) {
  attempt = attempt || 0;
  if (initJobIdCombobox(root) || attempt >= 15) return;
  window.setTimeout(function () {
    retryJobIdCombobox(root, attempt + 1);
  }, 50);
}

function initThreeDDrawingDepictor(root) {
  root = root || document;
  installDepictorGlobalHandlers();
  if (!jobIdComboboxEl(root)) {
    initFileViewerModal();
    return;
  }
  retryJobIdCombobox(root);
  window.requestAnimationFrame(function () {
    initJobIdCombobox(root);
  });
  initFileViewerModal();
}

// Exposed for the SSR data-needs-init registry.
window.initThreeDDrawingDepictor = initThreeDDrawingDepictor;

// Open a front-report row as its own page. The custom landing can't render through
// the grid's in-place swap without nesting inside the listing wrapper and clipping
// the status grid, so we navigate like opening the record's URL directly. Capture +
// stopImmediatePropagation also suppresses the grid's default (nesting) open.
function openDepictorRecordFullPage(event) {
  if (!(event.target instanceof Element)) return;
  if (!event.target.closest('[id^="ssr-threedrawingdepictor-listing"]')) return;
  var row = event.target.closest('.ag-row');
  if (!row) return;
  var link = row.querySelector('a[href*="jobidmaster_pk"]');
  if (!link) return;
  var href = link.getAttribute('href');
  var token = new URLSearchParams(window.location.search).get('apitoken')
    || (document.querySelector("[name='apitoken']") || {}).value;
  if (token && href.indexOf('apitoken=') === -1) {
    href += (href.indexOf('?') >= 0 ? '&' : '?') + 'apitoken=' + encodeURIComponent(token);
  }
  event.preventDefault();
  event.stopImmediatePropagation();
  window.location.assign(href);
}

function closeFileViewerModal() {
  var modal = document.getElementById('file-viewer-modal');
  if (modal) modal.remove();
}

function installDepictorGlobalHandlers() {
  if (depictorHandlersInstalled) return;
  depictorHandlersInstalled = true;

  document.addEventListener('dblclick', openDepictorRecordFullPage, true);

  document.addEventListener('click', function (event) {
    var modal = document.getElementById('file-viewer-modal');
    if (!modal) return;
    if (!(event.target instanceof Element)) return;
    var target = event.target;
    if (
      target === modal
      || target.closest('#file-viewer-close-btn')
      || target.closest('#closeButton')
    ) {
      closeFileViewerModal();
      return;
    }
    var maximize = target.closest('#file-viewer-maximize-btn');
    if (!maximize) return;

    var container = document.getElementById('file-viewer-container');
    var pdfContainer = document.getElementById('viewer-pdf-container');
    if (!container) return;

    var isMaximized = container.dataset.maximized === 'true';
    container.dataset.maximized = isMaximized ? 'false' : 'true';
    container.classList.toggle('max-w-6xl', isMaximized);
    container.classList.toggle('max-h-[90vh]', isMaximized);
    container.classList.toggle('rounded-lg', isMaximized);
    container.classList.toggle('max-w-none', !isMaximized);
    container.classList.toggle('max-h-none', !isMaximized);
    container.classList.toggle('h-full', !isMaximized);
    container.classList.toggle('w-full', !isMaximized);
    container.classList.toggle('rounded-none', !isMaximized);
    maximize.title = isMaximized ? 'Maximize' : 'Restore';
    maximize.setAttribute(
      'aria-label',
      isMaximized ? 'Maximize viewer' : 'Restore viewer',
    );
    if (pdfContainer) {
      pdfContainer.classList.toggle('h-[600px]', isMaximized);
      pdfContainer.classList.toggle('h-full', !isMaximized);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeFileViewerModal();
    }
  });
}
